export class MoreAboutPerson {
    jobId: number;
    jobDescription: string;
    participantType: number;
    typeSignature: number;
    orderParticipant: number;
    enterpriseName: string;
    enterpriseTradeNameView: string;
    enterpriseDocumentNumber: string;
    enterpriseDocumentNumberView: string;
    enterpriseNameView: string;
    roles: string;
    typePerson: number;
    rolesDescription: string;
    operatorId: number;
    operationId: number;
    operationDescription: string;
    rolesNameView: string;
    operationCompleted: number;
    rubricFilename: string;
    base64RubricFile: string;
    rubricFileExtension: string;
    documentFrontBase64Data: string;
    documentFrontFilename: string;
    documentFrontFileExtension: string;
    documentRearBase64Data: string;
    documentRearFilename: string;
    documentRearFileExtension: string;
    file: string;
    hasStampRubric: boolean;
    // tiene sus imagenes de documento de identidad
    hasImagesDocument: boolean;
    // tiene su vigencia de poder
    hasPowerValidity: boolean;
    hasRUCFile: boolean;
    incompleteData: boolean;
    isOneSignSignature: boolean;
    haveTwoFactorAuthentication: boolean;
    haveChangePasswordTemporary: boolean;
    haveSecurityLevelPassword: boolean;
    labels: number[];
    passwordSecurityLevel: any;
    temporaryPasswordChange: any;
}
